import { FC } from 'react';
import { Container } from '@/components/ui/Container';
import { CORE_FEATURES } from '@/utils/constants';

const STATS = [
  { value: '1,000+', label: '活跃开发者' },
  { value: '20+',    label: '编程语言' },
  { value: '99.9%',  label: '服务可用性' },
  { value: '24/7',   label: '技术支持' },
];

export const FeaturesSection: FC = () => {
  return (
    <section id="features" className="py-24 bg-apple-light-gray">
      <Container>
        {/* 区块标题 */}
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <h2
            className="font-bold text-apple-dark mb-4"
            style={{ fontSize: 'clamp(1.875rem, 4vw, 3rem)', lineHeight: 1.1, letterSpacing: '-0.025em' }}
          >
            为什么选择白茆AI？
          </h2>
          <p className="text-lg text-apple-gray leading-relaxed">
            基于最先进的 Claude 技术，提供专业级的 AI 编程辅助体验
          </p>
        </div>

        {/* 特性网格 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-20">
          {CORE_FEATURES.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-apple-lg p-7 shadow-apple-sm hover:shadow-apple transition-shadow duration-300"
            >
              {/* 图标容器 */}
              <div className="w-11 h-11 rounded-apple bg-[#EBF5FF] flex items-center justify-center mb-5 text-xl">
                {feature.icon}
              </div>
              <h3
                className="font-semibold text-apple-dark mb-2 text-lg"
                style={{ letterSpacing: '-0.015em' }}
              >
                {feature.title}
              </h3>
              <p className="text-[15px] text-apple-gray leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* 数据统计行 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-apple-separator rounded-apple-lg overflow-hidden shadow-apple-sm">
          {STATS.map(({ value, label }) => (
            <div key={label} className="bg-white py-8 text-center">
              <div
                className="font-bold text-apple-dark mb-1"
                style={{ fontSize: '2rem', letterSpacing: '-0.025em' }}
              >
                {value}
              </div>
              <div className="text-sm text-apple-gray">{label}</div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};
